/**
 * 工具方法，依赖jquery
 * @type {{get: HttpRequest.get, post: HttpRequest.post, jsonp: HttpRequest.jsonp}}
 */
var md5 = require('md5');

/**
 *
 |*|  * docCookies.setItem(name, value[, end[, path[, domain[, secure]]]])
 |*|  * docCookies.getItem(name)
 |*|  * docCookies.removeItem(name[, path[, domain]])
 |*|  * docCookies.hasItem(name)
 |*|  * docCookies.keys()
 *
 * @type {{getItem: docCookies.getItem, setItem: docCookies.setItem, removeItem: docCookies.removeItem, hasItem: docCookies.hasItem, keys: docCookies.keys}}
 */
let docCookies = {
    getItem: function (sKey) {
        return decodeURIComponent(document.cookie.replace(new RegExp("(?:(?:^|.*;)\\s*" + encodeURIComponent(sKey).replace(/[-.+*]/g, "\\$&") + "\\s*\\=\\s*([^;]*).*$)|^.*$"), "$1")) || null;
    },
    setItem: function (sKey, sValue, vEnd, sPath, sDomain, bSecure) {
        if (!sKey || /^(?:expires|max\-age|path|domain|secure)$/i.test(sKey)) { return false; }
        let sExpires = "";
        if (vEnd) {
            switch (vEnd.constructor) {
                case Number:
                    sExpires = vEnd === Infinity ? "; expires=Fri, 31 Dec 9999 23:59:59 GMT" : "; max-age=" + vEnd;
                    break;
                case String:
                    sExpires = "; expires=" + vEnd;
                    break;
                case Date:
                    sExpires = "; expires=" + vEnd.toUTCString();
                    break;
            }
        }
        document.cookie = encodeURIComponent(sKey) + "=" + encodeURIComponent(sValue) + sExpires + (sDomain ? "; domain=" + sDomain : "") + (sPath ? "; path=" + sPath : "") + (bSecure ? "; secure" : "");
        return true;
    },
    removeItem: function (sKey, sPath, sDomain) {
        if (!sKey || !this.hasItem(sKey)) { return false; }
        document.cookie = encodeURIComponent(sKey) + "=; expires=Thu, 01 Jan 1970 00:00:00 GMT" + ( sDomain ? "; domain=" + sDomain : "") + ( sPath ? "; path=" + sPath : "");
        return true;
    },
    hasItem: function (sKey) {
        return (new RegExp("(?:^|;\\s*)" + encodeURIComponent(sKey).replace(/[-.+*]/g, "\\$&") + "\\s*\\=")).test(document.cookie);
    },
    keys: function () {
        let aKeys = document.cookie.replace(/((?:^|\s*;)[^\=]+)(?=;|$)|^\s*|\s*(?:\=[^;]*)?(?:\1|$)/g, "").split(/\s*(?:\=[^;]*)?;\s*/);
        for (let nIdx = 0; nIdx < aKeys.length; nIdx++) { aKeys[nIdx] = decodeURIComponent(aKeys[nIdx]); }
        return aKeys;
    }
};

let HttpRequest = {
    setUp: function (options) {
        if (options.crossDomain) {
            $.ajaxSetup({crossDomain: true, xhrFields: {withCredentials: true}});
        }
    },
    get: function (url, data, options, success, error) {
        this.setUp(options);
        if (! data) data = {};
        if (! data['t'] && (url.indexOf('?t=') < 0 && url.indexOf('&t=') < 0)) {
            data['t'] = (new Date().getTime() / 1e3).toFixed(0);
        }

        if (options.isSign) {
            let sign_data = data;
            sign_data['ac'] = options.ac.toString().toLowerCase();
            data['sign'] = Sign(sign_data);
            delete data['ac'];
        }
        $.ajax({
            url: url,
            type: 'GET',
            data: data,
            dataType: 'json',
            success: success,
            error: error,
        })
    },
    post: function (url, data, options, success, error) {
        this.setUp(options);

        if (! data) data = {};
        if (! data['t'] && (url.indexOf('?t=') < 0 && url.indexOf('&t=') < 0)) {
            data['t'] = (new Date().getTime() / 1e3).toFixed(0);
        }

        if (options.isSign) {
            let sign_data = data;
            sign_data['ac'] = options.ac.toString().toLowerCase();
            data['sign'] = Sign(sign_data);
            delete data['ac'];
        }

        $.ajax({
            url: url,
            type: 'POST',
            data: data,
            dataType: 'json',
            success: success,
            error: error,
        })
    },
    jsonp: function (url, data, options, success, error) {
        if (! data['t'] && (url.indexOf('?t=') < 0 && url.indexOf('&t=') < 0)) {
            data['t'] = (new Date().getTime() / 1e3).toFixed(0);
        }
        let jsonpCallback = 'callback';

        if (options.isSign) {
            let sign_data = data;
            sign_data['ac'] = options.ac;
            sign_data['callback'] = jsonpCallback;
            data['sign'] = Sign(sign_data);
            delete data['ac'];
            delete data['callback'];
        }
        $.ajax({
            url: url,
            type: 'GET',
            data: data,
            dataType: 'jsonp',
            jsonpCallback: jsonpCallback,
            cache: true,
            success: success,
            error: error,
        })
    }
};

let Validator = {
    /**
     * 手机号验证
     * @param phone
     * @return {boolean}
     */
    validatePhone: function (phone) {
        const reg = /^1(3[0-9]|4[5,7,9]|5[0,1,2,3,5,6,7,8,9]|6[2,5,6,7]|7[0,1,2,3,5,6,7,8]|8[0-9]|9[1,2,3,8,9])\d{8}$/;
        return reg.test(phone);
    },

    /**
     * email验证
     * @param email
     * @return {boolean}
     */
    validateEmail: function (email) {
        const reg = /^([a-zA-Z0-9]+[_|\.\-]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,4}$/;
        return reg.test(email);
    }
};

/**
 * 参数签名
 * @param data
 * @return {string|Buffer}
 * @constructor
 */
let Sign = (data) => {
    let keys = Object.keys(data);
    keys.sort();

    let str = '';
    keys.forEach(k => {
        str += k.toString() + data[k]
    });

    return md5(md5(str) + data['ac']);
};

let getUrlParams = function () {
    let url = location.search;
    let theRequest = {};
    if (url.indexOf("?") !== -1) {
        let str = url.substr(url.indexOf("?") + 1);
        let strs = str.split("&");
        for(let i = 0; i < strs.length; i ++) {
            theRequest[strs[i].split("=")[0]]=unescape(decodeURIComponent(strs[i].split("=")[1].replace(/%/g, '%25')));
        }
    }
    return theRequest;
};

//验证码
function secCodeImg() {
    return '/do/seccode/?rand='+Math.random();
}

/**
 * 验证码校验
 * @param data
 * @param options
 * @param success
 * @param fail
 */
function checkSecCode(data, options, success, fail) {
    if (! Object.keys(data).length) {
        fail && 'function' === typeof fail && fail();
        return ;
    }

    HttpRequest.get('/do/check_seccode', data, {}, (res) => {
        if (res.is_success == 1) {
            success && 'function' === typeof success && success();
        } else {
            fail && 'function' === typeof fail && fail()
        }
    });
}

/**
 * 弹出式登录框的滑块验证
 * @param capt_url
 * @return {*|jQuery|HTMLElement}
 */
let createSmallCaptcha = (capt_url) => {
    let $dom = $(`
            <div class="small-captcha" style="display: block;">
                <div class="container">
                    <iframe name="smallCaptcha" src="${capt_url}" frameborder="0"></iframe>
                </div>
            </div>`);

    return $dom;
};

/**
 * 创建全屏弹出式滑块验证
 * @param capt_url
 * @return {*|jQuery|HTMLElement}
 */
let createPopupCaptcha = (capt_url) => {
    let $dom = $(`<div class="popup-captcha">
            <div class="container">
                <iframe name="popupCaptcha" src="${capt_url}" frameborder="0"></iframe>
                <i class="close"></i>
            </div>
        </div>`);

    $('body').append($dom);

    $dom.find('.close').on('click', function () {
        $('.popup-captcha').remove();
    });

    return $dom;
};

let Inputing = {
    // 输入数字/手机号
    Number: function () {
        $(this).val($(this).val().replace(/[^\d]/g,''));
    },
};

let isCommonEmail = (mail) => {
    let arr = [
        'qq.com',
        '163.com',
        '139.com',
        'sina.com',
        'yeah.com',
        '126.com',
        '21cn.com',
        'gmail.com',
        'yahoo.com',
        'msn.com',
        'hotmail.com',
        'aol.com',
        'ask.com',
        'live.com',
    ];

    return arr.indexOf(mail.toLowerCase()) > -1;
};

/**
 * 当前时间到第二天0点的秒数
 * 用于一些cookie的过期时长
 * @return {number}
 */
let getNextDayZeroSeconds = () => {
    let date = new Date();
    let year = date.getFullYear();
    let month = date.getMonth() + 1;
    let day = date.getDate() + 1;
    let string2timestamp = year+"/"+month+"/"+day+" 00:00:00";
    return (Date.parse(string2timestamp) - Date.parse(new Date()))/1000;
};

export default {
    HttpRequest,
    Validator,
    Cookies: docCookies,
    UrlParams: getUrlParams,
    DataSign: Sign,
    secCodeImg,
    checkSecCode,
    createSmallCaptcha,
    createPopupCaptcha,
    Inputing,
    isCommonEmail,
    getNextDayZeroSeconds,
}